import React from 'react'
import { useContainerQuery } from 'react-container-query'
import classnames from 'classnames'
import getGridDimsCN from '../CardGrid/utils/getGridDimsCN'
import StyledCardGridCN from './CardGridCN.style'

export interface Props {
	className?: string
	children: React.ReactNode
	header?: any
}

const query = {
	'grid-of-1': {
		maxWidth: getGridDimsCN(2).minWidth - 1,
	},
	'grid-of-2': {
		minWidth: getGridDimsCN(2).minWidth,
	},
	'grid-of-3': {
		minWidth: getGridDimsCN(3).minWidth,
	},
	'grid-of-4': {
		minWidth: getGridDimsCN(4).minWidth,
	},
	'grid-of-5': {
		minWidth: getGridDimsCN(5).minWidth,
	},
	'grid-of-6': {
		minWidth: getGridDimsCN(6).minWidth,
	},
}

export const CardGridCN = ({ className = '', children, header, ...props }: Props) => {
	// @ts-ignore
	const [params, containerRef] = useContainerQuery(query)

	return (
		<StyledCardGridCN
			data-testid="CardGridCN"
			className={classnames(params, className)}
			ref={containerRef}
			{...props}
		>
			<div className="CardGridCN__container">
				{header && <div className="CardGridCN__header">{header}</div>}
				<div className="CardGridCN__grid">{children}</div>
			</div>
		</StyledCardGridCN>
	)
}

export default CardGridCN
